import { Component, ViewChild, OnInit, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { ToolInventoryTransferService } from '../tool-inventory-transfer.service';
import {
  AssignmentTypeModel,
  AssignmentTypeParams,
  AssignmentGroups,
  FacilityModel,
  FacilityParams,
  JobParams,
  OwnerParams,
  ShopParams,
  UserParams,
  VendorParams,
  ParamsMappingForTransfer,
} from '../tool-inventory-transfer.model';
import { ToolsService } from 'src/app/service/tools/tools.service';
import {
  AutoCompleteFetchModel,
  AutoCompleteSelectModel,
} from 'src/app/component/shared/autocomplete/autocomplete.model';
import { MomentService } from 'src/app/service/shared/moment/moment.service';

@Component({
  selector: 'app-tool-inventory-transfer-assignment',
  templateUrl: './tool-inventory-transfer-assignment.component.html',
  styleUrls: ['./tool-inventory-transfer-assignment.component.scss'],
})
export class ToolInventoryTransferAssignmentComponent implements OnInit {
  @ViewChild('jobsAutocomplete') jobsAutocomplete;
  @ViewChild('ownersAutocomplete') ownersAutocomplete;
  @ViewChild('facilitiesAutocomplete') facilitiesAutocomplete;
  @ViewChild('usersAutocomplete') usersAutocomplete;
  @ViewChild('shopsAutocomplete') shopsAutocomplete;
  @ViewChild('vendorsAutocomplete') vendorsAutocomplete;

  facilities: Array<FacilityModel> = [];
  assignmentTypes: Array<AssignmentTypeModel> = [];

  selectedFacility: number;

  jobParams = JobParams;
  ownerParams = OwnerParams;
  facilityParams = FacilityParams;
  userParams = UserParams;
  shopParams = ShopParams;
  vendorParams = VendorParams;
  assignmentTypeParams = AssignmentTypeParams;
  paramsMappingForTransfer = ParamsMappingForTransfer;
  transferDropDown: any = {
    jobs: [],
    owners: [],
    facilities: [],
    users: [],
    shops: [],
    vendors: [],
  };
  paginationData: any = {
    jobs: {},
    owners: {},
    facilities: {},
    users: {},
    shops: {},
    vendors: {},
  };
  assignmentGroups: Array<string> = [
    AssignmentGroups.AssignedToJob,
    AssignmentGroups.AssignedToEmployee,
    AssignmentGroups.AssignedToShop,
    AssignmentGroups.OutForRepair,
    AssignmentGroups.Other,
  ];

  assignmentGroup: string = '';
  assignedDate: string;

  constructor(
    private toolsService: ToolsService,
    private toolInventoryTransferService: ToolInventoryTransferService,
    private momentService: MomentService,
    private changeDetectorRef: ChangeDetectorRef,
  ) { }

  ngAfterViewInit() {
    this.assignedDate = this.currentDate();
    this.addInventoryDate();
  }

  changeFieldGroup(event: Event) {
    const { value } = <HTMLInputElement>event.target;
    this.assignmentGroup = value;
    this.toolInventoryTransferService.clearModelData();
    if (this.assignmentGroup === AssignmentGroups.Other) {
      this.fetchAssignmentTypes();
    }
  }

  ngOnInit() {
    this.initDropDown();
  }

  ngOnChanges(): void {
    this.initDropDown();
  }

  initDropDown() {
    this.paramsMappingForTransfer.forEach(element => {
      this.toolsService.list[element.name](element.param).subscribe(res => {
        this.transferDropDown[element.name] = res.data;
        this.paginationData[element.name] = res.pagination;
      });
    });
  }

  fetch(model: AutoCompleteFetchModel) {
    const { namespace, search } = model;
    const autocomplete = this.autoCompleteMap[namespace];
    let params = this.paramsMap[namespace];
    params = { ...params, search };
    this.toolsService.list[namespace](params).subscribe(res => {
      autocomplete.fetchSuccessHandler(res);
    });
  }

  fetchNext(model: AutoCompleteFetchModel) {
    const { namespace, page } = model;
    const autocomplete = this.autoCompleteMap[namespace];
    let params = this.paramsMap[namespace];
    params = { ...params, page };
    this.toolsService.list[namespace](params).subscribe(res => {
      autocomplete.fetchNextSuccessHandler(res);
    });
  }

  fetchOwners(model: AutoCompleteSelectModel) {
    const { id, item } = model;
    if (id !== 'facilityId') return;
    this.ownerParams = { ...this.ownerParams, search: item.ownerId };
    this.toolsService.list['owners']({
      ...this.ownerParams,
      operator: 'eq',
    }).subscribe(res => {
      const owner = res.data[0];
      this.ownersAutocomplete.setSearch(owner.id);
      this.toolInventoryTransferService.addModelData({
        key: 'ownerId',
        value: owner.id,
      });
    });
  }

  fetchFacilities(model: AutoCompleteSelectModel) {
    const { id, item } = model;
    if (id !== 'ownerId') return;
    this.facilityParams = { ...this.facilityParams, search: item.id };
    this.toolsService.list['facilities']({
      ...this.facilityParams,
      operator: 'eq',
    }).subscribe(res => {
      const facility = res.data[0];
      this.transferDropDown['facilities'] = res.data;
      this.paginationData['facilities'] = res.pagination;
      this.changeDetectorRef.detectChanges();
      this.facilitiesAutocomplete.setSearch(facility.id);
      this.toolInventoryTransferService.addModelData({
        key: 'facilityId',
        value: facility.id,
      });
    });
  }

  fetchAssignmentTypes() {
    this.toolsService.list['assignment_types'](this.assignmentTypeParams).subscribe(res => {
      this.assignmentTypes = res.data;
    });
  }

  fillJobsData(model: AutoCompleteSelectModel) {
    if (model?.item) {
      const { item, id } = model;
      this.toolInventoryTransferService.addModelData({ key: id, value: item.id });
      this.fillJobRelatedData(model);
      this.fetchOwners(model);
      this.fetchFacilities(model);
    } else {
      this.toolInventoryTransferService.removeModelData({
        key: model.id ? model.id : 'jobId',
        value: null,
      });
      this.fillJobRelatedData(model);
    }
  }

  fillJobRelatedData(model: AutoCompleteSelectModel) {
    if (model) {
      const { item, id } = model;
      if (id !== 'jobId') return;
      const { potentialJobDetail } = item || {};
      if (potentialJobDetail) {
        const { facility } = potentialJobDetail;
        const { owner } = potentialJobDetail;

        if (facility && owner) {
          this.toolsService.list['owners'](this.ownerParams).subscribe(res => {
            this.transferDropDown['owners'] = res.data;
            this.paginationData['owners'] = res.pagination;
            // this.changeDetectorRef.detectChanges()
            this.ownersAutocomplete.setSearch(owner.id);
            this.toolInventoryTransferService.addModelData({
              key: 'ownerId',
              value: owner.id,
            });

            this.toolsService.list['facilities'](this.facilityParams).subscribe(res => {
              this.transferDropDown['facilities'] = res.data;
              this.paginationData['facilities'] = res.pagination;
              this.changeDetectorRef.detectChanges();
              this.facilitiesAutocomplete.setSearch(facility.id);
              this.toolInventoryTransferService.addModelData({
                key: 'facilityId',
                value: facility.id,
              });
            });
          });
        } else if (facility) {
          this.toolsService.list['facilities'](this.facilityParams).subscribe(res => {
            this.transferDropDown['facilities'] = res.data;
            this.paginationData['facilities'] = res.pagination;
            // this.changeDetectorRef.detectChanges()
            this.facilitiesAutocomplete.setSearch(facility.id);
            this.toolInventoryTransferService.addModelData({
              key: 'facilityId',
              value: facility.id,
            });
          });
        } else if (owner) {
          this.toolsService.list['owners'](this.ownerParams).subscribe(res => {
            this.transferDropDown['owners'] = res.data;
            this.paginationData['owners'] = res.pagination;
            // this.changeDetectorRef.detectChanges()
            this.ownersAutocomplete.setSearch(owner.id);
            this.toolInventoryTransferService.addModelData({
              key: 'ownerId',
              value: owner.id,
            });
          });
        }
        // this.changeDetectorRef.detectChanges()
      } else {
        this.facilitiesAutocomplete.setSearch(null);
        this.ownersAutocomplete.setSearch(null);
      }
    } else {
      this.facilitiesAutocomplete.setSearch(null);
      this.ownersAutocomplete.setSearch(null);
    }
  }

  selectAssignmentType(event: Event) {
    const { value } = <HTMLInputElement>event.target;
    this.toolInventoryTransferService.addModelData({
      key: 'typeId',
      value: parseInt(value),
    });
  }

  addTransferNotes(event: Event) {
    const { value } = <HTMLInputElement>event.target;
    this.toolInventoryTransferService.addModelData({ key: 'notes', value });
  }

  handleInventoryDate(event: Event) {
    const { value } = <HTMLInputElement>event.target;
    // if(!this.dateIsValid(value)) return;
    this.assignedDate = value;
    this.addInventoryDate();
  }

  addInventoryDate() {
    const date = this.momentService.formateDate(this.assignedDate);
    this.toolInventoryTransferService.addModelData({ key: 'assignedDate', value: date });
  }

  dateIsValid(value: string) {
    const formattedDate = this.momentService.formateDate(value, 'YYYY-MM-DD');
    const date = new Date(formattedDate);
    const now = new Date();

    const prev_date = new Date(now);
    prev_date.setMonth(now.getMonth() - 3);

    if (date >= prev_date) {
      this.assignedDate;
      return false;
    }

    return true;
  }

  handleCancel() {
    this.toolInventoryTransferService.close();
  }

  handleTransfer(transferKey?: string) {
    const DropdownList = document.getElementById('selectAssignment') as HTMLSelectElement;
    DropdownList.selectedIndex = 0;
    this.assignmentGroup = '';
    this.assignedDate = this.currentDate();
    this.toolInventoryTransferService.submitTransfer(transferKey)
  }

  currentDate() {
    return this.momentService.getCurrentDate();
  }

  previousDate() {
    return this.momentService.getPastDate(90, 'days');
  }

  get autoCompleteMap() {
    return {
      jobs: this.jobsAutocomplete,
      owners: this.ownersAutocomplete,
      facilities: this.facilitiesAutocomplete,
      users: this.usersAutocomplete,
      shops: this.shopsAutocomplete,
      vendors: this.vendorsAutocomplete,
    };
  }

  get paramsMap() {
    return {
      jobs: this.jobParams,
      owners: this.ownerParams,
      facilities: this.facilityParams,
      users: this.userParams,
      shops: this.shopParams,
      vendors: this.vendorParams,
    };
  }

  get assignmentGroupsType(): typeof AssignmentGroups {
    return AssignmentGroups;
  }
}
